export const ActiveInquiryViewsEnum = {
    LeadInquiries: 1,
    MatchedUnit: 2,
    UnitOverview: 3,
  };

